var _defs, _path, _path2, _path3, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitsLine1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.21 216",
    strokeWidth: 3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illu_Linie_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M1.05,3.82c-.31,21,10.34,40,25.72,53.77,16.49,14.73,37,23.22,58.59,26.85,27.69,4.64,56,4.25,83.78.65,21.1-2.73,41.8-7.58,63-9.61,37.35-3.56,75.42-2.14,112.23,5.27,34.64,7,68.88,19.34,97.69,40.17,27.11,19.6,47.78,47,56.7,79.47,1.17,4.27,2.15,8.6,3,13,.58,3.16,5.4,1.82,4.82-1.33a148.54,148.54,0,0,0-49.4-85.51c-26.43-22.87-59.21-37.41-92.78-46.26-36.16-9.53-74-12.83-111.31-11.21a396,396,0,0,0-54.84,6.16c-27.09,5-54.14,8.58-81.77,7.44-24.3-1-49-4.62-70.31-17.12C28.53,55.17,13,39.18,7.79,19A57.18,57.18,0,0,1,6.05,3.82c0-3.22-5-3.22-5,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.27,123.43a137.62,137.62,0,0,1,54.7,53,191.41,191.41,0,0,1,9.59,18.83,2.53,2.53,0,0,0,3.42.9,2.58,2.58,0,0,0,.9-3.43A171.8,171.8,0,0,0,464.12,160a141.77,141.77,0,0,0-27.41-28,152.56,152.56,0,0,0-19.92-12.93c-2.82-1.55-5.35,2.77-2.52,4.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.4,9.16A27.1,27.1,0,0,0,21.31,29a2.5,2.5,0,0,0,3.54-3.54A22,22,0,0,1,19.4,9.16a2.5,2.5,0,1,0-5,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 406.53,
    cy: 116.27,
    r: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.53,
    cy: 112.27,
    r: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsLine1);
export default __webpack_public_path__ + "static/media/benefits_line_1.76b5c8d15029a7e772fbd82c2209316b.svg";
export { ForwardRef as ReactComponent };